import { defineAction } from '~/prix'
import { z } from 'zod'
import heavyMachineryFetchAction from './heavyMachineryFetch.action.json' with { type: 'json' }
import { heavyMachineryObject } from '../heavyMachineryObject'

const heavyMachineryFetchDefinition = defineAction({
  ...heavyMachineryFetchAction,

  input: z.object({
    id: z.string().uuid(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: heavyMachineryObject,
})

export default heavyMachineryFetchDefinition
